import type { IPageBreadcrumb } from '@/types/common';
import { useI18n } from 'vue-i18n';

/**
 * @description
 * Создает объекты хлебных крошек из pathname страницы.
 * Для полей title, использует i18n и конфиги интернационализации.
 */
const buildBreadcrumbsFromPathname = (urlPathname: string, locale = 'ru'): IPageBreadcrumb[] => {
  const { t } = useI18n();

  const fullPath: string = urlPathname.replace(/^\/[^/]{2,}/, '');
  const fullPathParts: string[] = fullPath.split('/').filter((el) => el);

  let route = `/${locale}`;

  return fullPathParts.reduce<IPageBreadcrumb[]>((acc, part) => {
    route += `/${part}`;
    return [...acc, { route, label: t(`breadCrumbs.${part}`) }];
  }, []);
};

export { buildBreadcrumbsFromPathname };
